module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/Coin-Wallet-c2495673885338ab.png"+" 24w",
        images: [{path: __webpack_public_path__ + "assets/images/Coin-Wallet-c2495673885338ab.png",width: 24,height: 24}],
        src: __webpack_public_path__ + "assets/images/Coin-Wallet-c2495673885338ab.png",
        toString: function(){return __webpack_public_path__ + "assets/images/Coin-Wallet-c2495673885338ab.png"},
        
        width: 24,
        height: 24
      }